import axios from 'axios';
import { operationDataEndpoint } from './endpoints';
import { getRequestHash } from '../utils/helpers';
import CustomError from '../utils/customError';
// import mockOperationData from '../mock/mockOperationData';
import userDataParser from '../utils/userDataParser';


const getOperationData = async (setOperationData, body ,setError) => {
  try {
    const requestHash = getRequestHash();
    if (!requestHash) {
      throw new CustomError({
        type: 'Not Found',
        message: '404 - Página no encontrada.',
      });
    }
    const response = await axios.post(operationDataEndpoint(requestHash), body);


    // const response = await mockOperationData(requestHash);
    if (parseInt(response.status) !== 200) {
      throw new CustomError({
        type: 'Error Fetching Data',
        message: 'Error al recuperar la información del usuario.',
      });
    }

    if (!response.data) {
      throw new CustomError({
        type: 'Request Not Found',
        message: 'No se ha encontrado un pedido asociado.',
      });
    }

    const operationId = response.data.id;

    const unparsedData = response.data; // full raw data
    const parsedUserData = userDataParser(unparsedData); // parsed data for generating contract and displaying user info
    setOperationData(unparsedData, parsedUserData);
    return { unparsedData, parsedUserData, operationId };
  } catch (error) {
    const errorType = error.response.data.extra.key;
    if (errorType !== 'invalid_document' && errorType !== 'invalid_otp') {
      setError(error);
    }
    console.log(error.response.data.key);
    return { error: error.response.data.extra.key }
  }
};

export default getOperationData;
